import { authConstants } from './constants';

import Cookies from 'universal-cookie';

var authService = require ('./api');

export const authActions = {
    login,
    logout,
    loadSession ,
    checkSession
};  
 

function loadSession ( sessionID ) {
    return function(dispatch) {
        authService.getSession(sessionID).then(
            session => {
                if ( !session || !session.session_id ) {
                    let cookies = new Cookies() ;
                    cookies.remove('sessionID', { path: '/' }) ;
                    cookies.remove('calID', { path: '/' }) ;
                    localStorage.clear() ;

                    dispatch( { type: authConstants.SESSION_NOT_FOUND } )
                }
                else if ( new Date(session.due_date) < new Date() ) {
                    let cookies = new Cookies() ;
                    cookies.remove('sessionID', { path: '/' }) ;
                    cookies.remove('calID', { path: '/' }) ;
                    localStorage.clear() ;

                    dispatch( { type: authConstants.SESSION_VOID  } )
                }
                else  {
                    authService.getSysParameters( session.jwt_token )
                    .then( json => {
                        dispatch( { 
                                    type: authConstants.LOAD_SYS_PARAMS,
                                    sysParams: json
                                  })
                    } ) ;
                    localStorage.setItem("session",JSON.stringify(session)) ;
                    if (session.user.birthdate) session.user.birthdate = session.user.birthdate.replace('Z','')
                    dispatch( { type: authConstants.SESSION_OK, session: session  } )
                    
                }
            },
            error => {
                dispatch( { type: authConstants.SESSION_INVALID }  )
                }
    
            );
    }  
}

function login(schoolID, loginID, password) {
    let cookies = new Cookies() ;
    return function(dispatch) {
      dispatch({
        type: authConstants.LOGIN_REQUEST,
      });

      authService.login(schoolID, loginID, password).then(
                session => { 
                    if (!session || !session.session_id) {
                        dispatch( { type: authConstants.LOGIN_FAILURE} )
                    }
                    else {
                        cookies.set('token', session.session_id, { path: '/' });
                        cookies.set('sessionID', session.session_id, { path: '/' });
                        cookies.set('lastLogin', loginID, { path: '/' });
                        cookies.set('calID', session.calendar.calendar_id, { path: '/' }) ;

                        authService.getSysParameters( session.jwt_token )
                        .then( json => {
                            dispatch( { 
                                        type: authConstants.LOAD_SYS_PARAMS,
                                        sysParams: json
                                    })
                        } ) ;
                        
                        localStorage.setItem("session",JSON.stringify(session)) ;
                        dispatch( { type: authConstants.LOGIN_SUCCESS, session: session } );
                    }},
                error => {
                    dispatch( { type: authConstants.LOGIN_FAILURE, error }  )
                    }
        
                );
       
                            
    }
  }

  function checkSession( session ) {
      
    return function(dispatch) {
        if ( new Date(session.due_date) < new Date() ) {
            let cookies = new Cookies() ;
            cookies.remove('sessionID', { path: '/' }) ;
            cookies.remove('calID', { path: '/' }) ;
            localStorage.clear() ;
            dispatch( { type: authConstants.SESSION_VOID } );
        }
    }
}

  function logout() {
    let cookies = new Cookies() ;
    cookies.remove('sessionID', { path: '/' }) ;
    cookies.remove('calID', { path: '/' }) ;
    
    localStorage.clear() ;

    return { type: authConstants.LOGOUT };
}



